import jsCookie from 'js-cookie';

function setBrowserCookie(...args) {
  return jsCookie.set(...args);
}

function getBrowserCookie(...args) {
  return jsCookie.get(...args);
}

export {
  setBrowserCookie,
  getBrowserCookie,
};
